import { useState } from "react";

const DEFAULT_STACKS = [
  { id: "cs1", name: { en: "Morning Energy Protocol", es: "Protocolo Energía Matutina" }, author: "María S.", avatar: "MS", goal: "energy", pids: [10, 3, 7], likes: 234, copies: 89,
    comments: [
      { user: "Carlos M.", txt: { en: "This stack changed my mornings completely!", es: "¡Este stack cambió mis mañanas por completo!" }, date: "2026-03-25" },
      { user: "Ana G.", txt: { en: "Added spirulina to it and it's even better", es: "Le agregué espirulina y es aún mejor" }, date: "2026-03-26" },
    ], date: "2026-03-20" },
  { id: "cs2", name: { en: "Beast Mode Muscle Stack", es: "Stack Músculo Modo Bestia" }, author: "Juan P.", avatar: "JP", goal: "muscle", pids: [1, 14, 4, 11], likes: 567, copies: 203,
    comments: [{ user: "Luis R.", txt: { en: "Gained 4lbs lean mass in 6 weeks with this", es: "Gané 2kg de masa magra en 6 semanas con esto" }, date: "2026-03-22" }], date: "2026-03-15" },
  { id: "cs3", name: { en: "Deep Sleep Recovery", es: "Recuperación Sueño Profundo" }, author: "Sofía P.", avatar: "SP", goal: "recovery", pids: [9, 6, 7], likes: 412, copies: 156,
    comments: [{ user: "María S.", txt: { en: "My Oura sleep score went from 65 to 85!", es: "¡Mi puntuación Oura de sueño subió de 65 a 85!" }, date: "2026-03-24" }], date: "2026-03-18" },
  { id: "cs4", name: { en: "Immunity Shield Daily", es: "Escudo Inmune Diario" }, author: "Carlos M.", avatar: "CM", goal: "immunity", pids: [3, 2, 5], likes: 189, copies: 67, comments: [], date: "2026-03-22" },
  { id: "cs5", name: { en: "Caribbean Glow Stack", es: "Stack Brillo Caribeño" }, author: "Ana G.", avatar: "AG", goal: "wellness", pids: [7, 10, 2], likes: 321, copies: 112,
    comments: [{ user: "Sofía P.", txt: { en: "Perfect for the beach lifestyle!", es: "¡Perfecto para el estilo de vida playero!" }, date: "2026-03-27" }], date: "2026-03-19" },
];

/** Community stacks list + UI controls (tabs, comment drafts, create form). */
export function useCommunity() {
  const [commStacks, setCommStacks] = useState(DEFAULT_STACKS);
  const [commTab, setCommTab] = useState<"top" | "new" | "my">("top");
  const [commCommentInput, setCommCommentInput] = useState<Record<string, string>>({});
  const [myStackName, setMyStackName] = useState("");
  const [showCreateStack, setShowCreateStack] = useState(false);

  return {
    commStacks, setCommStacks,
    commTab, setCommTab,
    commCommentInput, setCommCommentInput,
    myStackName, setMyStackName,
    showCreateStack, setShowCreateStack,
  };
}